/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Theme } from '@mui/material';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { exportProductAuthorizationPdf } from '../common/AuthorizationModel';
import { categories, Category } from '../common/Categories';
import { exportData } from '../common/common';
import { loadFromLocalStorage } from '../common/localStorage';
import { history } from '../store/history';
import { dataTableRenderer, loadTableData } from './AuthorizationRenderer';

interface Props {
  classes?: any;
}
const styles = (theme: Theme) => ({
  table: {
    width: '100%',
    padding: '12px'
  }, progress: {
    margin: theme.spacing(2)
  },
  progressWrap: {
    textAlign: 'center' as const,
    marginTop: '20vh'
  },
});

class AllProductAuthorizations extends React.Component<Props>{
  state = {
      selectedCategory: categories.find((category: Category) => {
          return category.id === 12;
      }),
    xaxisData: [],
    dataSets: [],
    rows: [],
    totalRows: 0,
    isLoading: true,
    initialLoading: true,
    isModuleEnabled: false,
    norecords: false
  };
  componentDidMount() {
    const enabledModules: Array<any> = loadFromLocalStorage('Enabled Modules');
    let isModuleEnabled = false;
    if (this.state.selectedCategory !== undefined) {
        isModuleEnabled = enabledModules !== undefined ?
            enabledModules.find(x => this.state.selectedCategory !== undefined && x.modulename === this.state.selectedCategory.moduleName) !== undefined : false;
    }
    this.setState({ isModuleEnabled });
    if (!isModuleEnabled) {
      history.push('/app/authorization');
      return;
    }

    this.loadData({ pageno: 1, pagesize: 10 });
  }
  async loadData(extras: any) {
    if (this.state.selectedCategory !== undefined) {
      this.setState({ isLoading: true, rows: [] });      
      const data = await loadTableData(extras, this.state.selectedCategory);
      if (data !== undefined) {
        this.setState({
            rows: data.rows, totalRows: data.totalRows, isLoading: false, initialLoading: false, norecords: data.totalRows > 0 ? false : (this.state.initialLoading)
        });
       }
      
    }
  }
  refreshChart() {

  }
  handleExport = async (exportType: any, selectedColumns: any) => {
    const mode = 'p';
    const columnHeaders: Object = exportProductAuthorizationPdf, fileName = 'AllProductAuthorizations';
    try {
      if (navigator.onLine) {
        if (this.state.selectedCategory !== undefined) {
          const data = await loadTableData(`query{ 
	allProductAuthorization  
	{ 
		count
        data{
            companyname,
            companyId,
            twodProductModelName,
            twodProductName,
            twodProductFamily
        }  
	} 
}	`, this.state.selectedCategory,true);
          if (data !== undefined) {
            exportData(selectedColumns, data.rows, exportType, fileName, columnHeaders, mode);
          }
        }

      }
    } catch (e) { }
  };

  render() {
    const { classes } = this.props;
    const { initialLoading, selectedCategory, rows, totalRows, isLoading, isModuleEnabled, norecords } = this.state;
    
    return (
        isModuleEnabled && dataTableRenderer(classes, initialLoading, selectedCategory, rows, totalRows,
            this.refreshChart.bind(this), this.loadData.bind(this), this.handleExport.bind(this), isLoading, norecords)

    );
  }
}

export default withStyles(styles)(AllProductAuthorizations);
